module.exports = "/Comment@2x-24acb99edfd1a32d8ba0a1765aa380b1.png";